<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      :title="ModelNase.title"
      :id="ModelNase.id"
      :close="plotItem_click"
    >
      <template slot="content">
        <div class="content">
          <el-select
            v-model="value"
            placeholder="请选择"
            size="small"
            style="width: 80%"
            @change="changeGltf"
            popper-class="my-popper"
          >
            <el-option
              v-for="(item, index) in gltf_list"
              :key="index"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <!-- <i @click="deleteAll" class="el-icon-delete iconDelete"></i> -->
          <div class="img_content">
            <img
              v-for="(item, index) in imgList"
              :key="item.imageUrl"
              :src="item.imageUrl"
              :class="index == pitchOnindex ? 'pitchOn' : ''"
              alt=""
              @click="showModel(item, index)"
            />
          </div>
        </div>

        <ModalEditor
          ref="ModalEditor"
          v-cloak
          v-if="modalEditorShow"
          @modalEditorClose="modalEditorClose"
          @openEditor="openEditor"
          @lastStep="lastStep"
          @onSubmit="onSubmit"
          @batchCreate="batchCreate"
          :graphic="graphic"
        ></ModalEditor>
      </template>

      <template slot="foot" v-if="batchData">
        <div class="foot-operate">
          <el-button type="primary" @click="escDispose">
            上一步
          </el-button>

          <el-button type="primary" @click="the_next_step">
            下一步
          </el-button>
        </div>
      </template>
    </MapModal>
  </div>
</template>

<script>
import * as ModelNaseWork from "./ModelNase";
const MapModal = () => import("@/components/common/mapModal/Index");
const ModalEditor = () => import("./ModalEditor");
import gltf_list from "./gltf_list.json";
import { BimGltfPaintingAdd } from "@/api/api";
export default {
  data() {
    return {
      ModelNase: {
        title: "新建模型",
        id: "ModelNase",
      },
      modalNode: {
        ModelNase: {
          show: true,
          loading: false,
          // 样式配置 定位使用
          // style: "margin: 106px 0 0 -706px;",
          offset: {
            // 默认弹出层偏移
            // x: 106,
            // y: -376,
            x: 55,
            y: -300,
            // unit: "px", // 默认px
          },
          width: "232px",
          // auto 自适应
          height: `${document.querySelector(".cesium-widget").offsetHeight -
            160}px`, // 配置模态框中心高度
          // height: `${document.querySelector(".cesium-widget").offsetHeight -
          //   30}px`, // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      modalEditorShow: false,
      gltf_list: gltf_list,
      value: "landscape",
      imgList: [],

      graphic: null,
      batchData: null,
      changeGltfData: null,
      getDxpList: [],
      pitchOnindex: null,
    };
  },
  components: {
    MapModal,
    ModalEditor,
  },
  props: {
    close: {
      type: Function,
    },
  },

  created() {},
  mounted() {
    ModelNaseWork.Initialization();
    this.$eventBus.$on("startDrawSuccess", () => {
      this.modalNode.ModelNase.head.fold.state = false;
      this.modalEditorShow = true;
      setTimeout(() => {
        this.$nextTick(() => {
          console.log("打开编辑页面");
          this.$refs.ModalEditor.modalNode.ModelNase.show = true;
        });
      }, 300);
    });

    let url = this.$GLOBAL.localResourcesPath + "Upload";
    gltf_list.forEach((el) => {
      el.list.forEach((value) => {
        value.imageUrl = url + value.image;
        value.style.url = url + value.style.urlPath;
      });
    });

    this.changeGltfData = this.gltf_list[0];
    this.imgList = this.gltf_list[0].list;
  },
  methods: {
    // 关闭当前标绘子组件弹窗
    plotItem_click() {
      // this.$emit("modelNaseClose", "ModelNase");
      // this.close("ModelNase");
      this.modalNode.ModelNase.show = false;
      this.$emit("openState");
    },
    showModel(item, index) {
      this.pitchOnindex = index;
      if (this.batchData) {
        ModelNaseWork.addDemoGraphic(item, this.batchData);
      } else {
        ModelNaseWork.startDrawModel(item);
        document.onkeydown = (e) => {
          let key = window.event.keyCode;
          if (key == 27) {
            ModelNaseWork.stopDraw();
          }
        };
      }
    },

    openEditor() {
      this.modalEditorShow = true;
    },
    modalEditorClose() {
      this.modalEditorShow = false;
      this.modalNode.ModelNase.head.fold.state = true;
      this.pitchOnindex = null;
    },

    deleteAll() {
      ModelNaseWork.deleteAll();
      this.modalEditorClose();
    },
    the_next_step() {
      this.modalNode.ModelNase.show = false;
      this.modalEditorShow = true;
    },
    lastStep() {
      this.modalNode.ModelNase.show = true;
      this.modalEditorShow = false;
    },
    onSubmit(obj) {
      let form = {
        projectId: 1,
        type: this.changeGltfData.name,
        textName: obj.properties.name,
        graphic: JSON.stringify(obj.properties),
        position: JSON.stringify(obj.geometry.coordinates),
        sort: 1,
        isShow: true,
        groupId: this.$parent.selectTreeData.id,
      };

      BimGltfPaintingAdd(form).then((res) => {
        if (res.status == 200 && res.data.code == 200) {
          this.successFun([res.data.data]);
        }
      });
    },
    async batchCreate(obj) {
      let arr = ModelNaseWork.batchCreate();
      let list = [];
      arr.forEach((el, i) => {
        let form = {
          projectId: 1,
          type: this.changeGltfData.name,
          textName: el.properties.name + "-" + ++i,
          graphic: JSON.stringify(el.properties),
          position: JSON.stringify(el.geometry.coordinates),
          sort: 1,
          isShow: true,
          groupId: this.$parent.selectTreeData.id,
        };
        list.push(this.getDxp(form));
      });
      this.getDxpList = [];
      const listAll = await Promise.all(list);
      this.successFun(this.getDxpList);

      // this.$parent.$parent.$parent.$parent.modalNode.viewpoint.head.fold.state = true;
      // this.$emit("modalEditorClose");
      // ModelNaseWork.deleteAll();
    },
    async getDxp(form) {
      await BimGltfPaintingAdd(form).then((res) => {
        if (res.status == 200 && res.data.code == 200) {
          this.getDxpList.push(res.data.data);
        }
      });
    },
    async successFun(ids) {
      this.$parent.getData();
      this.modalEditorShow = false;
      this.$message({
        type: "success",
        message: "成功!",
      });
      // this.$parent.modalNode.viewpoint.head.fold.state = true;
      this.$parent.modalNode.viewpoint.show = true;
      this.$eventBus.$emit("clear_graphicLayer");
      this.$parent.modelNaseShow = false;
      await this.deleteAll();
      this.$parent.open_new_model(ids);
    },
    escDispose() {
      this.$parent.modelNaseShow = false;
      this.$eventBus.$emit("startDrawGraphic");
      ModelNaseWork.deleteAll();
    },
    changeGltf(value) {
      this.gltf_list.forEach((el) => {
        if (el.value == value) {
          this.changeGltfData = el;
          this.imgList = el.list;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  padding: 10px;
}

.img_content {
  width: 100%;
  /* height: 100%; */
  max-height: 752px;
  overflow-y: auto;
  /* overflow: hidden; */
  padding-top: 15px;
}
.img_content > img {
  width: 98px;
  height: 90px;
  margin: 0 6px 15px 3px;
  cursor: pointer;
}
.pitchOn {
  border: 2px solid rgb(255, 255, 255);
}

.img_content > img:hover {
  // box-shadow: #9e9e9e;
  box-shadow: 5px 0px 20px rgb(255, 255, 255);
}
.scrollbarHidden::-webkit-scrollbar {
  width: 5px;
}
.scrollbarHidden::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #9e9e9e;
  box-shadow: inset 0 0 5px rgba(0, 122, 204, 0.6);
}
/* //滚动条底层颜色! */
.scrollbarHidden::-webkit-scrollbar-track {
  border-radius: 10px;
  background: #ededed;

  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
}
.iconDelete {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  position: relative;
  top: 8px;
  left: 2px;
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  .el-button.el-button--primary {
    margin: 0px 5px !important;
    font-size: 12px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}

// /deep/.el-input__inner {
//   background: rgb(0, 0, 0, 0) !important;
//   color: rgba(255, 255, 255, 0.9);
//   border-color: rgba(245, 245, 245, 0.6) !important;
// }
.img_content::-webkit-scrollbar {
  width: 0 !important;
}
.my-popper .el-select-dropdown__item {
  height: 27px !important;
  line-height: 27px !important;
}
</style>
